<template>
    <div class="navigation-buttons">
      <button class="link" v-on:click="handleClickNavigation('goBack')">Voltar</button>
      <button class="button primary" v-on:click="handleClickNavigation('forward')">Avançar</button>
    </div>
</template>

<script>
export default {
  name: "NavigationButtons",
  components: {
  },
  props: ["sendAnalytics", "menuActive"],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    handleClickNavigation(operation){
   
      this.$emit('clickNavigation', operation);
    }
  },
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.navigation-buttons{
  display: none;
  justify-content: space-between;
  align-items: center;

  padding: 1.2rem 2.8rem;
  gap: 2rem;

  position: absolute;
  right: 0;
  bottom: -4%;

  background-color: $color-light-default;
  border-radius: 16px 0px 0px 16px;

  box-shadow: 2px 2px 30px rgba(0, 0, 0, 0.1);

  z-index: 99;

  // button{
  //     padding: 8px 32px;
  //   }
}

@media(max-width: $bp-mobile){
  .navigation-buttons{
    display: flex;
    position: relative;

    width: 100%;
    // height: 234px;
    justify-content: center;

    padding: .7rem 0;

    // button{
    //   padding: 16px 32px;
    // }
  }
}

</style>